import { forwardRef } from "react";
import { Stream } from "@cloudflare/stream-react";

import { VideoProps } from "./types";

/**
 * Video component that supports both regular HTML video and Cloudflare Stream videos.
 *
 * @param props - The video properties
 * @returns the video component
 */
const Video = forwardRef<HTMLVideoElement | any, VideoProps>((props, ref) => {
  // Regular (MP4) videos
  if (!props.cloudflare) {
    const { cloudflare, src, className, ...attr } = props;
    return <video ref={ref} src={src} className={className} {...attr} />;
  }

  // Cloudflare Stream videos
  const { cloudflare, src, className, ...attr } = props;
  return (
    <Stream
      streamRef={ref as any}
      src={src}
      responsive={true}
      className={className}
      {...attr}
    />
  );
});

Video.displayName = "Video";

export { Video };
